import { Button } from "./ui/button";
import { TOUR } from "../constants/testIds";
import { Star, Plane, Moon, Utensils, CalendarDays, MapPin, BedDouble } from "lucide-react";

const StarRow = ({ n }) => (
  <span className="inline-flex text-yellow-400">
    {Array.from({ length: n || 0 }).map((_, i) => (
      <Star key={i} className="w-3.5 h-3.5 fill-current" />
    ))}
  </span>
);

export const TourCard = ({ tour, onSelect }) => (
  <div
    data-testid={TOUR.tourCard}
    className="group flex flex-col bg-white rounded-2xl overflow-hidden border border-[#EEDEC0] shadow-sm hover:shadow-2xl hover:-translate-y-1 transition-all duration-300"
  >
    <div className="relative aspect-[4/3] overflow-hidden">
      <img
        src={tour.image}
        alt={tour.hotel}
        loading="lazy"
        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
      />
      <div className="absolute top-3 left-3 flex flex-col gap-1.5">
        <div className="px-2.5 py-1 rounded-full bg-coral text-white text-xs font-bold shadow-lg">
          {tour.discount}
        </div>
        <div className="px-2.5 py-1 rounded-full bg-white/95 backdrop-blur text-[#063B4E] text-[10px] uppercase tracking-widest font-semibold">
          Предварительное предложение
        </div>
      </div>
      <div className="absolute top-3 right-3 px-2.5 py-1 rounded-full bg-white/95 backdrop-blur text-[#063B4E] text-sm font-bold shadow flex items-center gap-1">
        <span className="text-teal">{tour.rating.toFixed(1)}</span>
        <span className="text-[10px] text-[#4A5A6B] uppercase tracking-wider">оценка</span>
      </div>
    </div>

    <div className="p-5 flex-1 flex flex-col">
      <div className="flex items-center gap-2 mb-1">
        <StarRow n={tour.stars} />
        <span className="text-xs text-[#4A5A6B]">{tour.stars}★ отель</span>
      </div>
      <h3 className="font-display text-lg leading-tight text-[#063B4E]">{tour.hotel}</h3>
      <div className="text-sm text-[#4A5A6B] flex items-center gap-1.5 mt-1">
        <MapPin className="w-3.5 h-3.5 text-teal" />
        {tour.country}, {tour.city}
      </div>

      <div className="mt-4 grid grid-cols-2 gap-2 text-xs text-[#3E5060]">
        <div className="flex items-center gap-1.5"><CalendarDays className="w-3.5 h-3.5 text-teal" />{tour.date}</div>
        <div className="flex items-center gap-1.5"><Moon className="w-3.5 h-3.5 text-teal" />{tour.nights} ночей</div>
        <div className="flex items-center gap-1.5 truncate"><Utensils className="w-3.5 h-3.5 text-teal" />{tour.food}</div>
        <div className="flex items-center gap-1.5 truncate"><Plane className="w-3.5 h-3.5 text-teal" />{tour.airline}</div>
        <div className="flex items-center gap-1.5 truncate col-span-2"><BedDouble className="w-3.5 h-3.5 text-teal" />{tour.room}</div>
      </div>

      <div className="mt-5 flex items-end justify-between gap-3">
        <div>
          <div className="text-xs text-[#8A99A8] line-through">{tour.old_price}</div>
          <div className="text-2xl font-bold text-[#063B4E] leading-none">{tour.price}</div>
          <div className="text-[10px] text-[#8A99A8] mt-1">Цена ориентировочная</div>
        </div>
        <Button
          data-testid={TOUR.tourCardCta}
          onClick={() => onSelect(tour)}
          className="bg-teal hover:bg-[#0a616a] text-white rounded-full h-10 px-5 text-sm font-semibold whitespace-nowrap"
        >
          Хочу этот тур
        </Button>
      </div>

      <div className="mt-4 pt-3 border-t border-[#F0DFC1] text-[11px] text-[#8A99A8] leading-snug">
        Стоимость и наличие уточняются менеджером.
      </div>
    </div>
  </div>
);
